export default "__VITE_ASSET__DepKwHD3__ 67w";